<script>
import Title2Logo from '../modules/common/Title2Logo.vue'
import VideoPlayer from 'comp/common/VideoPlayer'

import { getFileType, richTextImgHandler } from '@/utils/common'
import { baseURL, prevSourseURL } from '@/utils/baseURL'
import { getSubPageDetail } from '@/api/pageData'

import * as pdf from 'pdfobject'
window.JSZip = require('jszip')

const Base64 = require('js-base64').Base64

export default {
  name: 'FilePreview',
  components: { Title2Logo, VideoPlayer },
  props: {
    type: {
      type: Number,
      default: 3 // 1-图文 2-图片 3-文件 100-视频
    },
    infoId: {
      type: Number,
      default: 0
    },
    previewShow: {
      type: Boolean,
      default: false
    },
    filename: {
      type: String,
      default: ''
    },
    headline: {
      type: String,
      default: ''
    },
    createtime: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    videoUrl: {
      type: String,
      default: ''
    },
    cover: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      prevSourseURL,
      filePreviewShowModal: false,
      fileType: '',
      officeUrl: '',
      pageData: {},
      DocEditor: null
    }
  },
  computed: {
    filenameCo() {
      return this.filename
    }
  },
  watch: {
    previewShow(newVal, oldVal) {
      if (newVal === false) {
        setTimeout(() => {
          this.filePreviewShowModal = false
        }, 400)
      } else {
        if (this.type === 1 || this.type === 0) {
          this.initPageData()
        }
        this.filePreviewShowModal = true
      }
    },
    filenameCo(newVal) {
      if (newVal) {
        this.fileType = getFileType(this.filenameCo)
        console.log({ filename: this.filenameCo, fileType: this.fileType })
        this.handleCheckFile()

        // if (this.type == 3 && this.fileType !== 'pdf') {
        //   if (this.DocEditor !== null) {
        //     this.DocEditor.destroyEditor()
        //   }
        //   this.setEditor()
        // }
      }
    }
  },
  mounted() {
  },
  beforeDestroy() {
    this.officeUrl = ''
    this.fileType = ''
  },
  methods: {
    getFileType, richTextImgHandler,
    handleModalClick() {
      this.$emit('onModalClick')
    },
    handleCheckFile() {
      const fileType = getFileType(this.filenameCo)
      const fullPath = `${baseURL}/Files/${this.filename}`
      if (fileType === 'pdf') {
        this.$nextTick(function() {
          pdf.embed(fullPath, '#pdf-content')
        })
      } // else this.preview()
    },
    setEditor(option) {
      const key = 'test' + Math.random() + ''
      const config = {
        document: {
          fileType: 'xlsx',
          key,
          title: 'my excel test.xlsx',
          url: 'https://hypadinterface.djplus.cn/Files/4.桐升社区森林防灭火工作网格化管理责任台账.xlsx',
          // "fileType": "spreadsheet",
          permissions: {
            comment: false,
            download: false,
            edit: false,
            fillForms: false,
            modifyContentControl: false,
            modifyFilter: false,
            print: true,
            review: false
          }
        },
        editorConfig: {
          lang: 'zh-CN',
          mode: 'view',
          customization: {
            chat: false,
            comments: false,
            compactHeader: true,
            compactToolbar: true,
            help: true
          }
        },
        documentType: 'spreadsheet', // text-text、sheet-spreadsheet、ppt-presentation
        width: '100%',
        height: '100%'
      }
      // eslint-disable-next-line no-undef
      this.DocEditor = new DocsAPI.DocEditor('vabOnlyOffice', config)
    },
    preview() {
      // 中保镇第四届人民代表人员表(132993002276940582).xls
      // https://hypadinterface.djplus.cn/Files/4.桐升社区森林防灭火工作网格化管理责任台账.xlsx
      // console.log('file path', url)
      // const officeUrl = 'https://view.officeapps.live.com/op/view.aspx?src=' + url
      // const officeUrl = 'https://wps-view.zhihuipk.com/?src=' + url
      // window.open(officeUrl, '_target')

      const fullPath = `${baseURL}/Files/${this.filename}`
      // const url = encodeURIComponent(fullPath)
      const url = Base64.encode(fullPath)
      // console.log('Base64', url)
      const officeUrl = 'http://cdjsc.com.cn:18012/onlinePreview?url=' + url
      this.officeUrl = officeUrl
      // this.filePreviewConfig.document.fileType = 'xlsx'
      // this.filePreviewConfig.document.title = this.filename
      // this.filePreviewConfig.document.url = fullPath
    },
    initPageData() {
      const params = { id: Number(this.infoId), userid: localStorage.getItem('screenUserid') || 0 }
      getSubPageDetail(params).then(res => {
        if (res.code === 0) this.pageData = res.msg[0]
      })
    }
  }
}
</script>

<template>
  <div v-show="filePreviewShowModal" class="dialog" @click.self="handleModalClick">
    <!-- <div v-if="type == 3 && fileType !== 'pdf'" id="vabOnlyOffice" class="gaword"></div> -->
    <div>
      <transition name="dialog-fade">
        <div v-if="previewShow" class="dialog-content">
          <div v-if="type == 3" class="dialog-content-main">
            <img
              class="close-btn"
              :src="require('imgs/close-btn.png')"
              alt="close-btn"
              @click="handleModalClick"
            >
            <title2-logo :headline="headline" />
            <p class="time">{{ createtime | formatDate('yyyy-MM-dd') }}</p>
            <div v-if="fileType === 'pdf'" id="pdf-content" class="file-content">
            </div>
            <div v-else class="file-content">
              <!-- file
              <div id="vabOnlyOffice" class="gaword"></div> -->
              <iframe
                sandbox="allow-popups allow-forms allow-scripts allow-top-navigation allow-same-origin"
                class="iframe"
                :src="`${prevSourseURL}/filePrev?file=${filenameCo}`"
              />
              <!-- <iframe
                sandbox="allow-popups allow-forms allow-scripts allow-top-navigation allow-same-origin"
                class="iframe"
                :src="officeUrl"
              /> -->
            </div>
          </div>

          <div v-else-if="type == 1 || type == 0" class="dialog-content-main">
            <img
              class="close-btn"
              :src="require('imgs/close-btn.png')"
              alt="close-btn"
              @click="handleModalClick"
            >
            <title2-logo :headline="pageData.headline" />
            <p v-if="pageData.createtime" class="time">{{ pageData.createtime | formatDate('yyyy-MM-dd') }}</p>
            <p class="rich-text" v-html="richTextImgHandler(pageData.memo)"></p>
          </div>

          <div v-else-if="type === 100" class="dialog-content-main">
            <img
              class="close-btn"
              :src="require('imgs/close-btn.png')"
              alt="close-btn"
              @click="handleModalClick"
            >
            <div class="video-box">
              <video-player :video-path="videoUrl" :video-cover="cover" />
            </div>
            <!-- <p class="video-title">{{ headline }}</p> -->
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<style lang="scss">
.dialog {
  iframe {
    overflow-y: scroll;
    &::-webkit-scrollbar { // chrome/safari
      display: none !important;
    }
    scrollbar-width: none !important; // firefox
    -ms-overflow-style: none !important; // IE10+
  }
}
</style>
<style lang="scss" scoped>
.dialog-fade-modal-enter-active {
  animation: dialog-fade-in 0.4s;
}
.dialog-fade-modal-leave-active {
  animation: dialog-fade-out 0.4s;
}

.dialog {
  width: 1920px;
  height: 100%;
  background: rgba(0, 0, 0, .3);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  display: flex;
  justify-content: center;
  .dialog-content {
    width: 1350px;
    height: 755px;
    background: #fff;
    border-radius: 10px;
    margin-top: 126px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .close-btn {
      position: absolute;
      bottom: 0;
      right: -54px;
      width: 44px;
      height: 44px;
      cursor: pointer;
    }
  }
  .dialog-content-main {
    width: 1330px;
    height: 735px;
    background: #fff;
    border: 2px solid #408490;
    border-radius: 8px;
    padding: 25px 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: scroll;
    overflow-x: hidden;
    // &::-webkit-scrollbar { // chrome/safari
    //   display: none;
    // }
    // scrollbar-width: none; // firefox
    // -ms-overflow-style: none; // IE10+
    &::-webkit-scrollbar { // chrome/safari
      width: 5px;
    }
    // scrollbar-width: none; // firefox
    // -ms-overflow-style: none; // IE10+
    &::-webkit-scrollbar-track {
      // background:#e4e4e4;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: #cdcdcd;
      border-radius: 3px;
    }
    .time {
      font-size: 14px;
      font-weight: bold;
      color: #B3B3B3;
      margin-top: 20px;
    }
    .rich-text {
      width: 80%;
      margin-top: 30px;
    }
  }

  .bottom-container {
    width: 1350px;
    height: 100px;
    // border: 1px solid #fff;
    margin-top: 30px;
  }
}

.file-content {
  width: 100%;
  height: 100%;
  margin-top: 20px;
}
// .gaword {
//   width: 100%;
//   height: 1000px;
// }
.iframe {
  width: 100%;
  height: 100%;
}
.video-title {
  font-size: 24px;
  font-weight: 800;
  color: #000;
  letter-spacing: 2px;
  margin-top: 10px;
}
.video-box {
  width: 1300px;
  height: 700px;
}

@keyframes dialog-fade-modal-in {
  0% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes dialog-fade-modal-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
}

.dialog-fade-enter-active {
  animation: dialog-fade-in 0.4s;
}
.dialog-fade-leave-active {
  animation: dialog-fade-out 0.4s;
}

@keyframes dialog-fade-in {
  0% {
    transform: translate3d(0, -20px, 0) scale(0);
    opacity: 0;
  }
  100% {
    transform: translate3d(0, 0, 0) scale(1);
    opacity: 1;
  }
}

@keyframes dialog-fade-out {
  0% {
    transform: translate3d(0, 0, 0) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, -20px, 0) scale(0);
    opacity: 0;
  }
}
</style>
